
/* eslint-disable */


// Polyfills for needed ES2017 (stage 4) features
// Object.values
import objValues from "object.values";
if (!Object.values) {
    objValues.shim();
}

//Object.entries
import objEntries from "object.entries";
if (!Object.entries) {
    objEntries.shim();
}

// Make a global jQuery because othewise angular uses jqLite,
// and we rely on jQuery features (via angular.element)

import jQuery from "jquery";
const $ = jQuery;
window.jQuery = jQuery;
window.$ = $;

//const auth0 = require("auth0-js");
//window.auth0 = auth0;

//make a global angular for backwards compat
import angular from "angular";
window.angular = angular;

//Make a global 'pako' for kendo to use later on.
import pako from "pako";
window.pako = pako;

const TbAppConfigFactory = require("../config/tb-app-config/TbAppConfigFactory").default;
const tbAppConfigFactory = new TbAppConfigFactory();

//load configuration information
tbAppConfigFactory.CreateFromKnownConfigLocationAsync().then(function(configData) {

    window.TbAppConfigData = configData; //Toss over 'wall' into angular app.

    const trackerbaseApp = require("../TrackerbaseApp");
    const trackerbaseAppName = trackerbaseApp.default;

    angular.element(document).ready(function() {
        angular.bootstrap(document, [trackerbaseAppName], {
            strictDi: true
        });
    });
});






//////////////////
// WEBPACK FOOTER
// ./src/core/bootstrap.js
// module id = Fh/I
// module chunks = 1